import { defineMessages } from "@ai360/core/intl";

export const messages = defineMessages({
    selectedDashboardPlaceholder: {
        id: "analytics.selectedDashboardPlaceholder",
        defaultMessage: "Dashboard",
    },
});
